import { CommonPopup } from '../commonPopup/commonPopup.component';
import { HIDE_POPUP_SIGNAL } from '../../popupContainer/popupContainer.constants';
import { navigateToAliasHome } from '../../routes/routes.utils';
import { t } from '../../i18n';

export class MaxParentalCodePopup extends CommonPopup {
  static _template() {
    return {
      ...super._template(),
      title: 'error.maxParentalCode',
    };
  }

  _getCloseButtonCaption = () => t('global.returnHome');

  _close() {
    navigateToAliasHome();
    this.signal(HIDE_POPUP_SIGNAL);
  }

  _handleBack() {
    this._close();
  }

  _handleEnter() {
    this._close();
  }
}
